import speedIcon from '../../../public/svg/icons/stellar/speed.svg';
import ultraLowFeesIcon from '../../../public/svg/icons/stellar/costs-that-make-sense.svg';
import builtForFinanceIcon from '../../../public/svg/icons/stellar/built-in-features.svg';
import greenAndMatureIcon from '../../../public/svg/icons/stellar/green-blockchain.svg';

export const whyStellarData = {
  mainText: `Why Stellar?`,
  description: ``,
  services: [
    {
      title: 'Speed and Finality That Matter',
      description:
        'Stellar reaches finality in about 5 seconds, and the network sustains real throughput of around 150 transactions per second. For payments and DeFi, that speed is what makes the use case work at all.',
      img: speedIcon,
    },
    {
      title: 'Costs That Make Sense',
      description:
        "Classic Stellar transaction fees are fractions of a cent, and Soroban's resource-metered model charges for the compute and storage a transaction uses. That makes high-volume use cases viable that wouldn't be economical on higher-fee chains.",
      img: ultraLowFeesIcon,
    },
    {
      title: 'Built for Payments and Finance',
      description:
        'A native DEX, path payments, the global anchor network, the SEP standards, and native USDC are already part of the ecosystem. That means less code to write and fewer moving parts to maintain.',
      img: builtForFinanceIcon,
    },
    {
      title: 'Green and Mature',
      description:
        "Stellar uses the Stellar Consensus Protocol rather than mining, so its energy use is negligible, and it has been closing ledgers since 2015. You're building on proven infrastructure with a long operating history.",
      img: greenAndMatureIcon,
    },
  ],
};
